import { getSuggestions } from '~/api';
import { MIN_SEARCH_LENGTH } from '~/scripts/constants';
import { useQuery } from './useQuery';

const useSuggestionsQuery = (term: string) => {
  return useQuery({
    queryKey: [term],
    async queryFn() {
      if (!term || term.length < MIN_SEARCH_LENGTH) {
        return [];
      }
      const suggestions = await getSuggestions(term);
      return suggestions;
    },
  });
};

export default useSuggestionsQuery;
